var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "map-zoom-box" }, [
    _c(
      "div",
      { staticStyle: { "margin-bottom": "0.5em" } },
      [
        _c("el-button", {
          style: {
            background: _vm.buttonTextColor ? "none" : "",
            opacity: _vm.buttonTextColor ? "0.75" : "",
            color: _vm.buttonTextColor,
            borderColor: _vm.buttonTextColor,
          },
          attrs: { size: "mini", icon: "el-icon-plus", circle: "" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.callParent("roamMap", true)
            },
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticStyle: { "margin-bottom": "0.5em" } },
      [
        _c("el-button", {
          style: {
            background: _vm.buttonTextColor ? "none" : "",
            opacity: _vm.buttonTextColor ? "0.75" : "",
            color: _vm.buttonTextColor,
            borderColor: _vm.buttonTextColor,
          },
          attrs: { size: "mini", icon: "el-icon-refresh", circle: "" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.callParent("resetZoom")
            },
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      [
        _c("el-button", {
          style: {
            background: _vm.buttonTextColor ? "none" : "",
            opacity: _vm.buttonTextColor ? "0.75" : "",
            color: _vm.buttonTextColor,
            borderColor: _vm.buttonTextColor,
          },
          attrs: { size: "mini", icon: "el-icon-minus", circle: "" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.callParent("roamMap", false)
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }